import { useMemo } from "react";

import EmergencyMatrix from "../EmergencyMatrix";
import buildEmergencyMatrixData from "../builders/buildEmergencyMatrixData";

export default function EmergencySection({
    emergenciaMonitor
}) {

    const matrixData = useMemo(
        () => buildEmergencyMatrixData(emergenciaMonitor),
        [emergenciaMonitor]
    );

    return (
        <EmergencyMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Emergência"
            rows={[
                {
                    label: "Alavanca",
                    type: "squares",
                    key: "alavanca"
                },
                {
                    label: "Botão soco",
                    type: "alert",
                    value: "ACIONADO NO CARRO",
                    key: "botaoSoco"
                }
            ]}
            matrixData={matrixData}
        />
    );
}